export default "/bunjo/images/search/map/pin-land-default.svg?3f58c38ca7c0c961f1798337ea2d6190";